module.exports = __webpack_public_path__ + "static/Tile1-Normal-footage-b3828b0737c2d40c3c31032184d0df64.gif";